import { Slice as ErrorAlertSlice } from "./redux/Slice";

export { ErrorAlertSlice };
